module.exports = __webpack_public_path__ + "static/img/logo3.2a6704fe.png";